<ion-header>
  <ion-toolbar color="primary">
    <ion-title class="ion-text-center">Add Payment Method</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-item lines="none" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>&nbsp;
    <ion-text>Loading...</ion-text>
  </ion-item>
  <ion-item *ngIf="errorMessage" color="danger" class="ion-text-wrap">
    {{errorMessage}}
  </ion-item>
  <ion-card *ngIf="keys && !isLoading">
    <ion-card-content>
      <ngx-stripe-payment #stripePaymentCtrl [clientSecret]="keys.paymentIntentClientSecret" [options]="options" />
      <ion-button color="success" expand="block" (click)="save()">Save</ion-button>
    </ion-card-content>
  </ion-card>
</ion-content>